import React from "react";
import { StyleSheet, Text, View } from "react-native";
import PayIcon from "../../../components/PayIcon";

export default function PaymentMethods({ data }) {
    return (
        <View style={styles.viewPrincipal}>
            <View>
                {data.map((item, index) => !(index % 2) ? <PayIcon item={item} key={index + index}/> : null)}
            </View>
            <View>
                {data.map((item, index) => (index % 2) ? <PayIcon item={item} key={index + index}/> : null)}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    viewPrincipal: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
})